<template>
    <div>
      <div
        class="card scroll-Container menu-bg-blue-transparent"
        :style="layersListMaxHeight"
      >
        <div class="card-body-padding">
          <!-- Customer Name Label -->
          <div class="ml-3 mb-1" style="width: 100%; justify-content: space-between; align-items: center; display: flex;">
            <strong>WCL Tool</strong>
          </div>
          <div v-if="selectedExtent" class="ml-3 mb-1">
            {{ getExtentAbbreviation() }} Coverage
          </div>
  
          <MMP_Analytics_LayerList
            class="panel-height pt-3"
            :customerProjectId="customerProjectId"
            :wclVisible="wclVisible"
            :wclLayersButtonsCtrl="wclLayersButtonsCtrl"
            :layerResponse="layerResponse"
            :map="map"
            :mmp_layersObj="mmp_layersObj"
            :otonomoSubcountry="otonomoSubcountry"
            :rules="rules"
            :selectAllControl="selectAllControl"
            :spinnerManager="spinnerManager"
            :zoomEnded="zoomEnded"
            :zoomLevelCap="zoomLevelCap"
            :showLidarPanel="showLidarPanel"
            :baseMapsOpen="baseMapsOpen"
            :extentsOpen="extentsOpen"
            @getErrorsLayer="$emit('getErrorsLayer', $event)"
            @getFilterModal="getFilterModal($event.layer, $event.id)"
            @getLegend="$emit('getLegend', $event)"
            @getShowAttributes="$emit('getShowAttributes', $event)"
            @layerButtonsChanged="$emit('layerButtonsChanged', $event)"
            @loadAttributes="$emit('loadAttributes', $event)"
            @toggleErrorsLayerVisibility="$emit('toggleErrorsLayerVisibility')"
            @toggleLayers="toggleDRTLayers()"
            @toggleLayerVisibility="$emit('toggleLayerVisibility', $event)"
            @toTopOfList="$emit('toTopOfList', $event)"
            @updateZoomEnded="$emit('updateZoomEnded', $event)"
          ></MMP_Analytics_LayerList>
        </div>
      </div>
    </div>
</template>

<style scoped>
.item:hover {
  background: rgba(65, 65, 65, 0.4);
  cursor: move;
}
.card {
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 350px;
}
.cursor {
  cursor: pointer;
}
.sortable:hover {
  color: rgb(30, 197, 132);
  transition: 0.5s;
}
.scroll-Container::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}
.scroll-Container::-webkit-scrollbar {
  width: 6px;
  background-color: #f5f5f5;
}
.scroll-Container::-webkit-scrollbar-thumb {
  background-color: #797777;
}
.info-tooltip {
  position: relative;
  display: inline-block;
}
.info-tooltip .info-tooltip-text {
  visibility: hidden;
  width: 210px;
  font-size: 15px;
  top: -40px;
  margin-left: 10px;
  background-color: #212529;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 200000;
}
.info-tooltip .zoom-tooltip-text {
  width: 210px;
  font-size: 15px;
  background-color: #212529;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  margin-left: 5px;
}
.info-tooltip:hover .info-tooltip-text {
  visibility: visible;
}
.center {
  text-align: center;
}
.hover:hover {
  color: rgb(30, 197, 132) !important;
}
.card-body-padding {
  padding-top: 0.5rem;
}
.change-database-text {
  position: absolute;
  color: #20ff9b;
  cursor: pointer;
  font-size: 14px;
  right: 10px;
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */
}
</style>

<script>
import axios from 'axios'
import draggable from 'vuedraggable'
import MMP_Analytics_LayerList from './MMP_Analytics_LayerList.vue'
export default {
  name: 'MMP_Analytics_Layers',
  components: {
    draggable,
    MMP_Analytics_LayerList
  },
  props: [
    'customerName',
    'customerProjectId',
    'dataset',
    'wclLayersButtonsCtrl',
    'wclVisible',
    'analyticsVisible',
    'layersListMaxHeight',
    'layerResponse',
    'map',
    'mmp_layersObj',
    'olSelectkey',
    'otonomoSubcountry',
    'persistingLayerFilters',
    'selectedExtent',
    'spinnerManager',
    'showDRTLayers',
    'user',
    'zoomEnded',
    'zoomLevelCap',
    'showLidarPanel',
    'baseMapsOpen',
    'extentsOpen'
  ],
  data() {
    return {
      drtLayersToggle: true,
      extentRecentlyChanged: true,
      filterClassesObj: null,
      filter_layer: null,
      filter_operator: null,
      filter_property: null,
      filter_value: null,
      filter_value_2: null,
      generateCQLObj: null,
      isErrorsLayer: false,
      isHidden: true,
      layerButtons: null,
      layerProperties: [],
      maintainView: false,
      maintainViewArr: [],
      operators: [
        {id: 1, tag: '<'},
        {id: 2, tag: '>'},
        {id: 3, tag: '='},
        {id: 4, tag: '<>'},
        {id: 5, tag: '<='},
        {id: 6, tag: '>='},
        {id: 7, tag: 'BETWEEN'}
      ],
      rules: [],
      selectedElement: null,
      selectAllControl: false,
      showLayers: false
    }
  },
  methods: {
    getExtentAbbreviation() {
      let retVal
      switch (this.selectedExtent) {
        case 'North America':
          retVal = 'NA'
          break;
        case 'Europe':
          retVal = 'EU'
          break;
        case 'Japan':
          retVal = 'JP'
          break;
        case 'South Korea':
          retVal = 'SK'
          break;
        case 'Middle East':
          retVal = 'ME'
          break;
      }
      return retVal;
    },
    getReleases(id) {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/release/project/' + id, {
            method: 'GET',
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            if (!content.errors) {
              if (this.user.role == 'Generic User') {
                // Changing dataset names for generic users
                for (let i = 0; i < content.length; i++) {
                  content[i].notes = 'Sample dataset-' + parseInt(i + 1)
                }
              }
              this.$emit('getReleases', content)
              this.release_id = content[0].id
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },
    checkLayer(layer) {
      // Checks if layer exists on the map
      let exists = false
      let mapLayersArr = this.map.getLayers().getArray()

      switch (typeof layer) {
        case 'object':
          for (let i in mapLayersArr) {
            // If layer exists, return true
            exists = mapLayersArr[i] === layer
            if (exists) {
              break
            }
          }
          break
        case 'string':
          for (let i in mapLayersArr) {
            // If layer exists, return true
            exists =
              mapLayersArr[i].values_.hasOwnProperty('name') &&
              mapLayersArr[i].values_.name === layer
            if (exists) {
              break
            }
          }
          break
      }

      return exists
    },
    getFilterModal(layer, id) {
      this.isErrorsLayer = layer == 'errors' ? true : false
      this.selectedElement = id
      this.filter_layer = layer
      /* This function clears all previous selections of rules and calls
      a function for getting filter properties based on layer selection */
      this.getFilterProperties()
      this.$bvModal.show('filterModal')
    },
    getCQLDateFilterString(prop, op, val, val2 = null) {
      /* Creates Date object with inputted value, converts the date to
      an ISO-formatted string, then removes unneeded data from the end
      of the string. */
      let date = this.getISOSubstring(val)
      let newDateMillis = 0
      let dayInMillis = 86400000
      let fourHourInMillis = 14400000
      let currentLayer = prop + ` `

      switch (op) {
        case '=':
          newDateMillis =
            this.getTimeInMillis(date) + dayInMillis - fourHourInMillis - 1
          currentLayer +=
            `DURING ` + date + ` / ` + this.getISOSubstring(newDateMillis)
          break
        case '>':
          newDateMillis = this.getTimeInMillis(date) - fourHourInMillis
          currentLayer += `AFTER ` + this.getISOSubstring(newDateMillis)
          break
        case '>=':
          newDateMillis = this.getTimeInMillis(date) - fourHourInMillis
          currentLayer += `AFTER ` + this.getISOSubstring(newDateMillis)
          break
        case '<':
          newDateMillis = this.getTimeInMillis(date) - fourHourInMillis
          currentLayer += `BEFORE ` + this.getISOSubstring(newDateMillis)
          break
        case '<=':
          newDateMillis = this.getTimeInMillis(date) - fourHourInMillis
          currentLayer += `BEFORE ` + this.getISOSubstring(newDateMillis)
          break
        case 'BETWEEN':
          let secondDate = this.getISOSubstring(val2)
          // Subtract an extra millisecond to avoid data from wrong date
          newDateMillis =
            this.getTimeInMillis(secondDate) +
            dayInMillis -
            fourHourInMillis -
            1
          currentLayer +=
            `DURING ` + date + ` / ` + this.getISOSubstring(newDateMillis)
          break
      }

      return currentLayer
    },
    getISOSubstring(date) {
      return new Date(date).toISOString().substring(0, 19) + `-04:00`
    },
    getTimeInMillis(date) {
      // Converts date from ISO formatted string to milliseconds
      return new Date(date).getTime()
    },
    toggleDRTLayers() {
      this.drtLayersToggle = !this.drtLayersToggle
    },
    getFilterProperties() {
      /* This function gets the current layer name and finds the source and store
      name of the layer. The url generated is completely dynamic and used for all
      customers. Describe feature gets the feature types from the geoserver layer. */
      let mmpLayer = this.mmp_layersObj[this.filter_layer]
      let layerType = mmpLayer.layer.getSource().params_.LAYERS
      let lastItem = layerType.split(':')[0]
      let url = mmpLayer.geoserverName.split('?')[0] + '?'

      // Geoserver Web Feature Service
      if (sessionStorage.token) {
        axios
          .get(url, {
            params: {
              service: 'WFS',
              version: '1.1.0',
              request: 'DescribeFeatureType',
              typename: layerType,
              name: this.filter_layer,
              wsName: lastItem,
              srsname: 'EPSG:4326',
              outputFormat: 'application/json',
              INFO_FORMAT: 'application/json',
              authkey: sessionStorage.token
            }
          })
          .then(response => {
            let tempProps = []
            response.data.featureTypes[0].properties.forEach(item => {
              tempProps.push({name: item.name})
            })
            this.layerProperties = tempProps
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },
    getFormattedDate(originalDateString) {
      let originalDateObj = new Date(originalDateString)
      let returnValue = originalDateObj
        .toLocaleString('en-US', {
          dateStyle: 'short'
        })
        .replace(/\//g, '.')
      return returnValue
    }
  },
  mounted() {
    this.layerButtons = this.wclLayersButtonsCtrl
    this.$emit('DLLChange')
  },
  updated() {
    this.$emit('DLLChange')
  },
  watch: {
    wclLayersButtonsCtrl: function (newValue, oldValue) {
      this.layerButtons = newValue
      let layerButtonsLoaded = newValue.length == this.layerResponse.length
      // Checks to see if drtLayersButtonsCtrl has finished being updated
      if (layerButtonsLoaded && !this.extentRecentlyChanged) {
        this.rules = this.persistingLayerFilters
        this.rules.forEach(rule => {
          /* Changing generateCQLObj will trigger a watch in MMP_LayerFilterModal.vue
          to refresh the CQL filter for this rule when the dynamic layer list is reordered */
          this.generateCQLObj = {
            layer: rule.layer,
            enableZoom: false
          }
        })
      } else if (layerButtonsLoaded) {
        // This is necessary for when the dataset is swapped to a new extent
        this.extentRecentlyChanged = false
      }
    },
    rules: function (newValue, oldValue) {
      /*
      REFACTORED: array obj comparison error
        originally had: oldValue != []
        now: oldValue.length != 0
        reason: [] != [] => true - javascript will return true if they are two different objects, which is the case
      */
      if (oldValue.length != 0) {
        this.$emit('rulesChanged', newValue)
      }
    },
    selectedExtent: function (newValue, oldValue) {
      this.extentRecentlyChanged = true
    }
  }
}
</script>